module.exports = __webpack_public_path__ + "img/slotmachine.795e5e92.png";